import React, { lazy, Suspense, useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { NavLink, useNavigate } from "react-router-dom";
import SwiperCarsouel from "../../componants/swipercarsouel/SwiperCarsouel";
import * as urls from "../../utils/URLConst";
import makeRequest from "../../utils/makeRequest";
import { Button, Card, Col, Row } from "react-bootstrap";
import { BiCartAlt, BiHomeAlt, BiLayerPlus, BiLeftArrowAlt, BiMenuAltLeft, BiSlider } from "react-icons/bi";
import Loader from "../../componants/loader/Loader";
import { useDispatch } from "react-redux";
import { handleLoader } from "../../redux/reducers/layout";
import toastNotify from "../../utils/ToastNotify";

const ProductDtlCom = lazy(() => import('./ProductDtlCom'));
const YourProductDtlListCom = lazy(() => import('./YourProductDtlListCom'));
const Representative = lazy(() => import('../dashboard/Representative'));


const ProductDetail = () => {
  const [apidataMatrix, setApiDataMatrix] = useState([]);

  const [apidataProduct, setApiDataProduct] = useState([]);
  const [apidataMyproductService, setApiDataMyProductService] = useState([]);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();
  const row = location.state;

  const fetchOrderDetail = useCallback(async (tranCode) => {
    try {
      dispatch(handleLoader(true));
      const data = {
        CUST_ITEM_ID: tranCode,
      };
      const result = await makeRequest("POST", urls.getOrderDetail, data, {});
      if (result.STATUS === "0") {
        const response = result.RESPONSE;
        setApiDataProduct(response[0]);
      } else {
        toastNotify(result.Message, "error");
      }
    } catch (error) {
      // ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }, [])

  const fetchProdcuServiceTable = useCallback(async () => {
    try {
      dispatch(handleLoader(true));
      const result = await makeRequest("POST", urls.getProductServiceTable, {});
      if (result.STATUS === "0") {
        const response = result.RESPONSE;
        setApiDataMyProductService(response);
      } else {
        toastNotify(result.Message, "error");
      }
    } catch (error) {
      // Ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }, [])

  const fetchEscalationMatrix = useCallback(async (itemId) => {
    try {
      dispatch(handleLoader(true));
      const data = {
        ITEM_CD: itemId !== "" ? itemId : row.ITEM_CD,
      };
      const result = await makeRequest(
        "POST",
        urls.getEscalationMatrix,
        data,
        {}
      );
      if (result.STATUS === "0") {
        const updateProductsName = result.RESPONSE[0].LEVEL_DTL.map((items) => ({
          ...items,
          AGENT_NM: items.NAME,
          AGENT_MOBILE: items.MOBILE,
          AGENT_EMAIL: items.EMAIL,
          ITEM_NM: result.RESPONSE[0].ITEM_NM
        }))

        setApiDataMatrix(updateProductsName);
      } else {
        result.MESSAGE !== "Not found!" && toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // submitErrorLogToApi(error);
    } finally {
      dispatch(handleLoader(false));
    }
  }, [])


  useEffect(() => {
    (async () => {
      await fetchOrderDetail(row?.TRAN_CD || row.ProductCode?.TRAN_CD);
      await fetchEscalationMatrix(row?.ITEM_CD || row.ProductCode?.ITEM_CD);
      // await fetchImplementionDetails(row?.TRAN_CD || row.ProductCode?.TRAN_CD);
      await fetchProdcuServiceTable(row?.TRAN_CD || row.ProductCode?.TRAN_CD);
    })();
  }, []);

  return (
    <>
      <div className="container-xxl  flex-grow-1 container-p-y">
        <div className="row container-top">
          <div className="col-lg-12 col-md-12 col-12">
            <div className="d-flex justify-content-between">
              <div className="pb-2">
                <span className="d-none d-md-inline"><BiHomeAlt />&nbsp;</span>
                <NavLink to="/dashboard" className={`text-secondary ${row.flag !== "M" ? "d-none d-md-inline" : ""} `}>
                  Dashboard /
                </NavLink>
                {row.flag === "M" &&
                  <>
                    < span className="ps-1 text-secondary">
                      My Order
                    </span>
                    <span className="d-none d-md-inline">/</span>
                  </>
                }
                <span className={`navigation-header-text ps-1 ${row.flag !== "M" ? "" : "d-none d-md-inline"}`}>
                  {apidataProduct?.ITEM_NM}
                </span>
              </div>
              <Button
                type="button"
                variant="warning"
                className="btn-sm"
                onClick={() => {
                  if (row.flag === "D") {
                    navigate("/dashboard");
                  } else {
                    navigate("/products", { state: row.filter });
                  }
                }}
              >
                <BiLeftArrowAlt className="text-lg me-1" />
                Back
              </Button>
            </div>
          </div>
        </div>

        <Row className="mt-2">
          <Col md={8}>
            <div className="pb-2 fw-semibold">
              <BiLayerPlus className="text-lg" />
              <span className="ps-2">Product & Service Details</span>
            </div>

            <Card style={{ minHeight: "270px" }} >
              <Card.Body>
                <Suspense fallback={<Loader isLoader={true} />}>
                  <ProductDtlCom data={apidataProduct} row={row} />
                </Suspense>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4} className="mt-md-0 mt-3">
            <div className="pb-2 fw-semibold">
              <BiCartAlt className="text-lg" />
              <span className="ps-2">Your Products & services</span>
            </div>

            <Card >
              <Card.Body className={`p-0 overflow-auto ${apidataMyproductService.filter((items) => items.TRAN_CD !== apidataProduct.TRAN_CD).length === 0 ? "d-flex justify-content-center align-items-center" : ""}`} style={{ height: 271 }}>
                {apidataMyproductService.filter((items) => items.TRAN_CD !== apidataProduct.TRAN_CD).length > 0 ?
                  <Suspense fallback={<Loader isLoader={true} />}>
                    <YourProductDtlListCom
                      data={apidataMyproductService.filter((items) => items.TRAN_CD !== apidataProduct.TRAN_CD)}
                      fetchEscalationMatrix={fetchEscalationMatrix}
                      fetchOrderDetail={fetchOrderDetail}
                    />
                  </Suspense>
                  :
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <div >
                      <img
                        src="/assets/images/No-data.jpg"
                        alt=""
                        style={{ width: 200 }}
                      />
                      <h4 className="mt-3 text-sm text-center"> No Representative Assigned </h4>
                    </div>
                  </div>
                }
              </Card.Body>
            </Card>
          </Col>

          <Col md={5} className="mt-3">
            <div className="pb-2 fw-semibold">
              <BiMenuAltLeft className="text-lg" />
              <span className="ps-2">Escalation Matrix</span>
            </div>

            <Card>
              <Card.Body>
                {apidataMatrix.length > 0 ?
                  <Suspense fallback={<Loader isLoader={true} />}>
                    <Representative data={apidataMatrix} height={288} />
                  </Suspense>
                  :
                  <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: 395 }}>
                    <div >
                      <img
                        src="./assets/images/No-data.jpg"
                        alt=""
                        style={{ width: 200 }}
                      />
                      <h4 className="mt-3 text-sm text-center"> No Representative Assigned </h4>
                    </div>
                  </div>
                }
              </Card.Body>
            </Card>
          </Col>

          <Col md={7} className="mt-3">
            <div className="pb-2 fw-semibold">
              <BiSlider className="text-lg" />
              <span className="ps-2"> Other Products & Services</span>
            </div>

            <Card>
              <Card.Body
                style={{
                  height: 335,
                  overflowY: "scroll",
                }}
              >
                <SwiperCarsouel count={5} />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div >
    </>
  );
};

export default ProductDetail;
